import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ClickableList from 'components/Shared/Layout/ClickableList';
import ExpandableSectionWithTitle from 'components/Shared/Layout/ExpandableSectionWithTitle';
import FeedItem from 'components/LeftMenu/MulticastFeeds/Item/container';
import { injectIntl } from 'react-intl';
import CatchError from 'components/CatchError';
import PlaceholderLeftMenu from 'components/LeftMenu/Shared/Placeholder';
import ErrorFormatter from 'components/Shared/Errors/Formatter';
import ContentErrorComponent from 'components/Shared/Errors/ContentError';

import ItemLoadings from '../Shared/ItemLoadings';

const formatMessages = intl => () => ({
    placeholderTitle: intl.formatMessage({
        id: 'menuLeft.feeds.placeholder.title',
        defaultMessage: 'Vous n\'avez pas encore créé de groupe de discussion'
    }),
    expandGroup: intl.formatMessage({
        id: 'menuLeft.feeds.link.expand.group',
        defaultMessage: 'Voir les autres groupes'
    }),
    collapseGroup: intl.formatMessage({
        id: 'menuLeft.feeds.link.collapse.group',
        defaultMessage: 'Cacher les autres groupes'
    }),
    group: intl.formatMessage({
        id: 'menuLeft.feeds.title',
        defaultMessage: 'Groupes'
    }),
    tooltipButtonPlus: intl.formatMessage({
        id: 'menuLeft.feeds.title.tooltip',
        defaultMessage: 'Créer un groupe'
    })
});

const ITEMS_DEFAULT_LENGTH = 5;

const MulticastFeeds = (props) => {
    const {
        isLoading,
        _feeds,
        intl,
        _currentFeed = '',
        openCreationDrawer,
        openEditionDrawer,
        _currentUser,
        error,
    } = props;
    let content = null;
    const i18n = formatMessages(intl)();
    const feedLength = _feeds ? _feeds.length : 0;

    const renderItem = useCallback(id => (
        <FeedItem
            id={id}
            onEdit={openEditionDrawer}
            _currentUser={_currentUser}
            _currentFeed={_currentFeed}
        />
    ), [openEditionDrawer, _currentUser, _currentFeed]);

    if (isLoading) {
        content = () => <ItemLoadings repeat={6} />;
    } else if (!feedLength && error) {
        content = () => (
            <ErrorFormatter
                error={error}
                render={ContentErrorComponent}
            />
        );
    } else if (feedLength) {
        content = isExpanded => (
            <CatchError>
                <ClickableList
                    items={_feeds && isExpanded ? _feeds : _feeds.slice(0, ITEMS_DEFAULT_LENGTH)}
                    _current={_currentFeed}
                >
                    {renderItem}
                </ClickableList>
            </CatchError>
        );
    }

    const placeholder = (
        <PlaceholderLeftMenu
            title={i18n.placeholderTitle}
        />
    );

    return (
        <ExpandableSectionWithTitle
            onAdd={openCreationDrawer}
            expandText={i18n.expandGroup}
            collapseText={i18n.collapseGroup}
            title={i18n.group}
            id="groups"
            tooltip={i18n.tooltipButtonPlus}
            isLoading={isLoading}
            placeholder={placeholder}
            itemsDefaultLength={ITEMS_DEFAULT_LENGTH}
            itemsLength={feedLength}
        >
            {content}
        </ExpandableSectionWithTitle>
    );
}

MulticastFeeds.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    _feeds: PropTypes.arrayOf(PropTypes.string),
    _currentFeed: PropTypes.string,
    _currentUser: PropTypes.string,
    intl: PropTypes.object.isRequired,
    openCreationDrawer: PropTypes.func.isRequired,
    openEditionDrawer: PropTypes.func.isRequired
};

export default injectIntl(MulticastFeeds);
